<template>
	<div>
		<!-- Submenu -->
		<policy-submenu />

		<!-- Body -->
		<core-layout-content large>
			<!-- Content -->
			<div class="flex wrap xs-12">
				<!-- Timetravel show when different than current state -->
				<div
					class="xs-12 bgWarning p0 mb4 r2"
					v-if="displayedEvent.type != 'current'"
				>
					<div class="flex xs-between xs-middle p4">
						<div class="xs-6">
							<div class="lh125">
								{{ $t("you_are_seing_data_from") }}
								<span class="fw7">
									{{
										$t("events_type." + displayedEvent.type) +
											" (" +
											displayedEvent.sublabel +
											")"
									}}
								</span>
								event
							</div>
						</div>
						<div>
							<j-button
								@click="$modal.show('timeline')"
								type="secondary"
								size="xsmall"
								>{{ $t("change") }}</j-button
							>
							<j-button
								@click="
									displayedEvent = { type: 'current' }
									fetchPolicy()
								"
								type="primary"
								size="xsmall"
								class="ml2"
								>{{ $t("go_back_to_present") }}</j-button
							>
						</div>
					</div>
				</div>

				<!-- Left  -->
				<div class="xs-12 md-7 p6" v-if="!policyIsFetched">
					<j-spinner size="small" :delay="0" />
				</div>
				<div class="xs-12 md-7 md-pr4" v-if="policyIsFetched != 0">
					<policy-detail-new-handler
						endorseType="policy"
						v-model="updates"
						:policyId="id"
						:policy="fetchedPolicy"
						:isEditable="isEditable"
						@policyDetail:remove="onChangePolicyDetail('remove')"
					>
						<div
							slot-scope="{
								policySection,
								holderSection,
								noHolderSection,
								productSection,
								insuredListSection,
								otherHoldersSection,
								premiumSection,
								clausesSection,
								benefitOptionsSection
							}"
						>
							<section-policy
								:componentProps="policySection.componentProps"
								:componentHandlers="policySection.componentHandlers"
								v-on="policySection.sectionHandlers"
								:startOpen="true"
								:showButtons="isEditable"
								class="bg5"
							/>

							<!-- MOCK: CMS mock of AEG specific facts that they can fill in -->
							<div v-if="isEditable">
								<aeg-policy-facts
									v-if="
										$store.state.tenantId === 'aeg' ||
											$store.state.tenantId === 'aeg_uat' ||
											$store.state.tenantId === 'demo_uat'
									"
									:facts="fetchedPolicy.facts || []"
									:policyId="fetchedPolicy.id"
									@close="fetchPolicy"
								/>
							</div>

							<section-product
								:componentProps="productSection.componentProps"
								v-on="productSection.sectionHandlers"
								:startOpen="true"
								:isEditable="
									isEditable &&
										![
											'aeg',
											'aeg_uat',
											'fiLife_uat',
											'fiLife',
											'hkecic_uat',
											'hkecic',
											'zurich_uat',
											'berkley_uat',
											'berkley',
											'demo_uat',
											'demo2_uat'
										].includes($store.state.tenantId)
								"
								class="bg5"
							/>

							<!-- MOCK cms : Pricing for each AEG product -->
							<!-- TODO: removed the condition on the product type when all products added -->
							<j-card
								v-if="
									($store.state.tenantId === 'aeg' ||
										$store.state.tenantId === 'aeg_uat' ||
										$store.state.tenantId === 'demo_uat') &&
										fetchedPolicy.product
								"
								class="mb2 bg5"
							>
								<j-accordion colorWhenClosed="bg0" class="cu1">
									<div slot="title" class="fs4 fw7">Pricing</div>
									<aeg-pricing
										slot="body"
										:productId="fetchedPolicy.product.productId"
										:policyId="id"
										:clauses="fetchedPolicy.clauses"
										:rawValues="fetchedPolicy.values"
										:contractInsured="fetchedPolicy.contractInsured"
										:isEditable="isEditable"
										:isPremiumOverriden="fetchedPolicy.isPremiumOverriden"
										@pricing:updated="fetchPolicy"
									/>
								</j-accordion>
							</j-card>

							<section-premium
								:componentProps="premiumSection.componentProps"
								:componentHandlers="premiumSection.componentHandlers"
								:startOpen="true"
								:showButtons="isEditable"
								class="bg5"
							/>

							<section-clauses
								:componentProps="clausesSection.componentProps"
								:componentHandlers="clausesSection.componentHandlers"
								:showButtons="isEditable"
								:showRemoveButton="isEditable"
								class="bg5"
							/>

							<!-- Contract holder -->
							<section-holder
								v-if="holderSection"
								:componentProps="holderSection.componentProps"
								:componentHandlers="holderSection.componentHandlers"
								v-on="holderSection.sectionHandlers"
								:showButtons="isEditable"
								class="bg5"
							/>
							<div v-else class="xs-12 bgWarning p0 mb4 r2">
								<div v-if="isCurrent" class="flex xs-between xs-middle p4">
									<div class="xs-6">
										<div class="lh125">
											{{ $t("errors.no_contract_holder") }}
										</div>
									</div>
									<div>
										<j-button
											@click="noHolderSection.openModal"
											type="primary"
											size="xsmall"
											class="ml2"
											>{{ $t("add") }}</j-button
										>
									</div>
								</div>
							</div>

							<!-- Other holders -->
							<div v-if="isEditable" class="flex xs-right xs-12">
								<j-button
									type="tertiary"
									class="mr4 mt2"
									@click="
										openAddEntity(
											'New Other Holder',
											'addOtherContractHolder',
											[
												{ name: 'Individual', value: 'individual' },
												{ name: 'Company', value: 'company' }
											]
										)
									"
									>{{ "+" + $t("add_other_holder") }}</j-button
								>
							</div>
							<section-other-holders
								:otherHoldersSection="otherHoldersSection"
								:showButtons="isEditable"
							/>

							<!-- Insured -->
							<div v-if="isEditable" class="flex xs-right xs-12">
								<j-button
									type="tertiary"
									class="mr4 mt2"
									@click="
										openAddEntity('New Insured', 'addContractInsured', [
											{ name: 'Individual', value: 'individual' },
											{ name: 'Company', value: 'company' },
											{ name: 'Object', value: 'object' }
										])
									"
									>{{ "+" + $t("add_insured") }}</j-button
								>
							</div>
							<section-insured
								:insuredListSection="insuredListSection"
								:showButtons="isEditable"
								@item:remove="onChangePolicyDetail('remove')"
							/>

							<!-- Benefit summary -->
							<j-card class="mb2 bg5">
								<j-accordion colorWhenClosed="bg0">
									<div slot="title" class="fs4 fw7">{{ $t("benefits") }}</div>
									<core-benefit-summary
										slot="body"
										:tree="fetchedPolicy.benefitSummary.benefitGraphs"
									/>
								</j-accordion>
							</j-card>

							<!-- Benefit Options -->
							<section-benefit-options
								v-if="
									!['aeg', 'aeg_uat', 'demo_uat'].includes(
										$store.state.tenantId
									)
								"
								v-bind="benefitOptionsSection.componentProps"
								v-on="benefitOptionsSection.sectionHandlers"
								:showButtons="false"
								class="bg5"
							/>
						</div>
					</policy-detail-new-handler>

					<!-- Beneficiaries Info -->
					<j-card class="mb2 bg5">
						<j-accordion colorWhenClosed="bg0">
							<div slot="title" class="fs4 fw7">{{ $t("beneficiaries") }}</div>
							<beneficiaries-info
								slot="body"
								class="pt2"
								:canWrite="isEditable"
								:list="computedBeneficiariesInfo"
								:showTitle="false"
								@removed="fetchPolicy"
								@added="fetchPolicy"
								@updated="fetchPolicy"
							/>
						</j-accordion>
					</j-card>

					<!-- Payment Info -->
					<j-card class="mb2 bg5">
						<j-accordion colorWhenClosed="bg0">
							<div slot="title" class="fs4 fw7">{{ $t("payment_info") }}</div>
							<payment-infos
								slot="body"
								class="pt2"
								:canWrite="isEditable"
								:list="computedPaymentInfo"
								:showTitle="false"
								@removed="fetchPolicy"
								@added="fetchPolicy"
								@updated="fetchPolicy"
							/>
						</j-accordion>
					</j-card>

					<!-- Associated contracts -->
					<j-card class="mb2 bg5">
						<j-accordion colorWhenClosed="bg0">
							<div slot="title" class="fs4 fw7">
								{{ $t("associated_contracts") }}
							</div>
							<associated-contracts-list
								slot="body"
								:showTitle="false"
								:showButtons="isEditable"
								:policyId="id"
							/>
						</j-accordion>
					</j-card>
				</div>

				<!-- Right -->
				<div class="xs-12 md-5 md-pl4">
					<!-- For apeiron, we have a toggle to share with case creator (using targettedPermssions) -->
					<apeiron-shared-with-user
						v-if="
							$store.state.tenantId === 'apeiron_uat' ||
								$store.state.tenantId === 'apeiron'
						"
						:policyId="id"
					/>

					<!-- Time travel -->
					<j-card class="bg5 p0">
						<div class="bg4 p4 fs5 lh125 fw7 c1">{{ $t("time_travel") }}</div>
						<div class="p4 lh125">
							{{ $t("time_travel_description") }}
							<div class="mt2">
								<j-button @click="$modal.show('timeline')" type="tertiary">{{
									$t("see_timeline")
								}}</j-button>
							</div>
						</div>
					</j-card>

					<!-- Info Widget -->
					<core-info-card :data="computedInfo" class="mt6" />

					<!-- Policy actions -->
					<policy-actions
						v-if="$store.state.settings.policies.actions.hasActions"
						v-can="'writePolicies'"
						class="mt6"
						:policyId="fetchedPolicy.id"
						:policyNumber="fetchedPolicy.issuerNumber"
						:amount="computedPricing.amount"
						:currencyCode="computedPricing.currencyCode"
						:context="fetchedPolicy"
					/>

					<!-- Info about cancellation -->
					<cancel-policy-info
						class="mt6"
						v-if="fetchedPolicy.status === 'CANCELLED'"
						:cancellationReason="fetchedPolicy.cancellationReason"
					/>

					<!-- Notes -->
					<core-notes-card
						class="mt6"
						notesOf="policy"
						:id="fetchedPolicy.id"
						:list="computedNotes"
						:canWrite="canWritePolicyNotes"
						@note:created="fetchPolicy"
						@note:updated="fetchPolicy"
						@note:deleted="fetchPolicy"
					/>

					<!-- Files -->
					<!-- read files in policy.attachements -->
					<core-files-card
						v-if="tenantId !== 'fiLife_uat'"
						class="mt6"
						:id="fetchedPolicy.id"
						filesOf="policy"
						:list="computedAttachments"
						:canWrite="canWriteFiles"
						@file:deleted="fetchPolicy"
						@files:uploaded="fetchPolicy"
					/>

					<!-- Files -->
					<!-- read files in file system using fileListingAPI -->
					<fi-life-files-card
						v-if="tenantId === 'fiLife_uat'"
						class="mt6"
						:id="fetchedPolicy.id"
						filesOf="custom"
						:list="computedFiles"
						:canWrite="canWriteFiles"
						@file:deleted="fetchFiles"
						@files:uploaded="fetchFiles"
					/>

					<!-- Policy Actions 2 -->
					<policy-actions-2
						class="mt6"
						:policyId="fetchedPolicy.id"
						:hasContractHolder="Boolean(fetchedPolicy.contractHolder)"
						:hasProduct="Boolean(fetchedPolicy.product)"
						v-if="isCurrent"
						@action:done="fetchPolicy"
					/>

					<!-- MOCK: Here we are mocking CMS and loading conditionaly component for AEG -->
					<aeg-policy-stakeholders
						class="mt6"
						v-if="
							isCurrent &&
								($store.state.tenantId === 'aeg_uat' ||
									$store.state.tenantId === 'aeg' ||
									$store.state.tenantId === 'demo_uat')
						"
					/>
				</div>
			</div>

			<!-- Bottom menu -->
			<div
				class="flex wrap xs-12 xs-right bt1 bc7 pt2 mt8"
				v-can="'writePolicies'"
			>
				<!-- Cancel -->
				<j-button
					v-if="
						$store.state.settings.policies.cancelling.hasCancel && isCurrent
					"
					type="secondary"
					@click="$modal.show('cancelPolicy')"
					action="showCancelPolicyModal"
					>{{ $t("cancel_policy") }}</j-button
				>
				<!-- Delete -->
				<j-button
					v-if="isCurrent"
					type="error"
					@click="$modal.show('j-dialog')"
					v-can="'writePolicies'"
					class="ml2"
					action="showDeletePolicyModal"
				>
					<crm-icon name="delete" size="normal" color="c5" class="mr1" />
					{{ $t("delete_policy") }}
				</j-button>
			</div>

			<!-- Cancel Policy Popup -->
			<core-modal name="cancelPolicy" :headline="$t('cancel_policy')">
				<cancel-policy v-bind="fetchedPolicy" @cancelled="afterCancellation" />
			</core-modal>
		</core-layout-content>

		<!-- Delete Confirmation Modal -->
		<j-dialog
			:title="$t('delete_policy')"
			type="delete"
			@confirm="onDelete(id)"
			>{{ $t("errors.are_you_sure_you_want_to_delete_policy") }}</j-dialog
		>

		<!-- Timeline modal -->
		<core-modal
			name="timeline"
			:headline="$t('timeline')"
			width="400px"
			:pivotX="0"
			:pivotY="0"
			:hasHeader="false"
		>
			<div class="bg5 pb16 p4" style="height:100vh; overflow-y: auto;">
				<policy-timeline :policyId="id" @item:click="travelToDate($event)" />
			</div>
		</core-modal>

		<!-- Loading toast -->
		<j-loading-toast v-if="isLoading" />

		<!-- Modal -->
		<core-modal
			name="modalEditor"
			:headline="updates.currentUpdate.label"
			:key="updates.currentUpdate.label"
			:width="updates.currentUpdate.modalWidth"
		>
			<div :class="{ p4: !updates.currentUpdate.noPadding }">
				<div v-if="!updates.currentUpdate.hideLabel" class="fw7 mb1">
					{{ updates.currentUpdate.label }}
				</div>
				<div>
					<component
						:is="updates.currentUpdate.component"
						v-model="updates.currentUpdate.value"
						@showButtons="updates.currentUpdate.hideButtons = false"
						v-bind="updates.currentUpdate.componentProps"
					/>
					<!-- Add empty component under, used for components that need to show options in multi select (e.g : CoreSelectBinders, CoreSelectProduct...)  -->
					<div
						v-if="updates.currentUpdate.whiteSpaceUnder"
						class="xs-12 pt15 pb15 mb5"
					/>
				</div>
				<div
					v-if="!updates.currentUpdate.hideButtons"
					class="flex xs-12 xs-between mt6"
					:class="{ 'pb4 pl4 pr4': updates.currentUpdate.noPadding }"
				>
					<j-button
						:isLoading="isLoading"
						v-if="updates.currentUpdate.type == 'add'"
						@click="onChangePolicyDetail('add')"
						>{{ $t("add") }}</j-button
					>
					<j-button
						v-else
						:isLoading="isLoading"
						@click="onChangePolicyDetail('update')"
						>{{ $t("update") }}</j-button
					>
					<j-button @click="$modal.hide('modalEditor')" type="bordered">{{
						$t("cancel")
					}}</j-button>
				</div>
			</div>
		</core-modal>
	</div>
</template>

<script>
import JAccordion from "@/components/JAccordion"
import PolicySubmenu from "./PolicySubmenu"
import JButton from "@/components/JButton/"
import JSpinner from "@/components/JSpinner/"
import JBaseToggle from "@/components/JBaseToggle/"
import JBaseInputNumber from "@/components/JBaseInputNumber/"
import JBaseInputText from "@/components/JBaseInputText/"
import JBaseDatePickerSimple from "@/components/JBaseDatePickerSimple/"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreModal from "@/modules/core/components/CoreModal"
import MainHolder from "./MainHolder"
import ProductInfo from "./ProductInfo"
import PremiumInfo from "./PremiumInfo"
import OtherHolders from "./OtherHolders"
import InsuredPeople from "./InsuredPeople"
import InsuredObjects from "./InsuredObjects"
import PaymentInfos from "./PaymentInfos"
import BeneficiariesInfo from "./BeneficiariesInfo"
import CancelPolicyInfo from "./CancelPolicyInfo"
import CoreNotesCard from "@/modules/core/components/CoreNotesCard/index.vue"
import JLoadingToast from "@/components/JLoadingToast"
import PolicyParticulars from "./PolicyParticulars"
import CancelPolicy from "./CancelPolicy"
import CoreFilesCard from "@/modules/core/components/CoreFilesCard"
import CoreInfoCard from "@/modules/core/components/CoreInfoCard"
import CrmIcon from "@/components/CrmIcon"
import PolicyActions from "./PolicyActions"
import ExclusionsInfo from "./ExclusionsInfo"
import PolicyBenefitOptions from "./PolicyBenefitOptions"
import CoreBenefitSummary from "@/modules/core/components/CoreBenefitSummary"
import CoreSelectBenefitOption from "@/modules/core/components/CoreSelectBenefitOption"
import CoreSelectProduct from "@/modules/core/components/CoreSelectProduct"
import AssociatedContractsList from "./AssociatedContractsList"
import JCard from "@/components/JCard"
import api from "../api/"
import globalApi from "@/api/gql.js"
import get from "lodash.get"
import JDialog from "@/components/JDialog/"
import { can } from "@/permissions/"
import PolicyClauses from "./PolicyClauses"
import PolicyActions2 from "./PolicyActions2/PolicyActions2.vue"
import PolicyTimeline from "./PolicyTimeline"
import PolicyDetailNewHandler from "./CurrentPolicyDisplay/PolicyDetailNewHandler"
import SectionPolicy from "../components/CurrentPolicyDisplay/SectionPolicy"
import SectionProduct from "../components/CurrentPolicyDisplay/SectionProduct"
import SectionHolder from "../components/CurrentPolicyDisplay/SectionHolder"
import SectionPremium from "../components/CurrentPolicyDisplay/SectionPremium"
import SectionClauses from "../components/CurrentPolicyDisplay/SectionClauses"
import SectionOtherHolders from "../components/CurrentPolicyDisplay/SectionOtherHolders"
import SectionInsured from "../components/CurrentPolicyDisplay/SectionInsured"
import SectionBenefitOptions from "../components/CurrentPolicyDisplay/SectionBenefitOptions"
import InputNewContact from "../components/InputModalComponents/InputNewContact"
import InputNewFact from "../components/InputModalComponents/InputNewFact"
import InputNewAddress from "../components/InputModalComponents/InputNewAddress"
import InputNewIdentity from "../components/InputModalComponents/InputNewIdentity"
import InputNatureOfBusiness from "../components/InputModalComponents/InputNatureOfBusiness"
import UpdateAddressInput from "../components/InputModalComponents/UpdateAddressInput"
import AddNewEntity from "../components/InputModalComponents/AddNewEntity"
import AdjustGrossPremium from "../components/AdjustGrossPremium"
import AddUpdateDiscount from "../components/AddUpdateDiscount"
import AddLoadings from "../components/CurrentPolicyDisplay/SectionPremium/AddLoadings"
import { gql } from "@/api/utils.js"
import JBaseInputLongText from "@/components/JBaseInputLongText"
import ClausesUpdate from "../components/CurrentPolicyDisplay/SectionClauses/ClausesUpdate"
import ClausesAdd from "../components/CurrentPolicyDisplay/SectionClauses/ClausesAdd"

// MOCK: CMS
import AegPolicyStakeholders from "./mockedCms/AegPolicyStakeholders"
import AegPolicyFacts from "./mockedCms/AegPolicyFacts"
import AegPricing from "../components/mockedCms/AegPricing"
import FiLifeFilesCard from "../components/mockedFiLife/FiLifeFilesCard"
import ApeironSharedWithUser from "./mockedApeiron/ApeironSharedWithUser"

export default {
	components: {
		JAccordion,
		AdjustGrossPremium,
		AddUpdateDiscount,
		AddLoadings,
		PolicySubmenu,
		JButton,
		JSpinner,
		JBaseInputNumber,
		JBaseToggle,
		CoreLayoutContent,
		CoreModal,
		OtherHolders,
		InsuredPeople,
		InsuredObjects,
		MainHolder,
		PaymentInfos,
		BeneficiariesInfo,
		CoreNotesCard,
		JLoadingToast,
		PolicyParticulars,
		CoreFilesCard,
		CoreInfoCard,
		ProductInfo,
		PremiumInfo,
		CancelPolicy,
		CrmIcon,
		CancelPolicyInfo,
		PolicyActions,
		ExclusionsInfo,
		PolicyBenefitOptions,
		CoreBenefitSummary,
		CoreSelectBenefitOption,
		CoreSelectProduct,
		AssociatedContractsList,
		JCard,
		JDialog,
		PolicyClauses,
		PolicyActions2,
		PolicyTimeline,
		JBaseInputText,
		JBaseDatePickerSimple,
		PolicyDetailNewHandler,
		SectionPolicy,
		SectionProduct,
		SectionHolder,
		SectionPremium,
		SectionClauses,
		SectionOtherHolders,
		SectionInsured,
		SectionBenefitOptions,
		InputNewAddress,
		InputNewIdentity,
		InputNewContact,
		InputNewFact,
		InputNatureOfBusiness,
		UpdateAddressInput,
		AddNewEntity,
		ClausesAdd,
		ClausesUpdate,
		JBaseInputLongText,

		// MOCK: CMS
		AegPolicyStakeholders,
		AegPolicyFacts,
		AegPricing,
		FiLifeFilesCard,
		ApeironSharedWithUser
	},
	props: {
		id: { type: String, required: true }
	},
	data() {
		return {
			displayedEvent: {
				type: "current"
			},
			isLoading: false,
			policyIsFetched: 0,
			fetchedFiles: [],
			fetchedPolicy: {},
			updates: {
				currentUpdate: {}
			}
		}
	},
	computed: {
		tenantId() {
			return this.$store.state.tenantId
		},
		isCurrent() {
			return this.displayedEvent.type === "current"
		},
		isEditable() {
			return !this.fetchedPolicy.isIssued && this.isCurrent
		},
		computedHolder() {
			return this.fetchedPolicy.contractHolder
				? this.fetchedPolicy.contractHolder
				: {}
		},
		computedOffers() {
			return this.fetchedPolicy.offers ? this.fetchedPolicy.offers : []
		},
		computedExclusions() {
			return this.fetchedPolicy.acceptedOffer
				? this.fetchedPolicy.acceptedOffer.exclusions
				: []
		},
		computedOtherHolders() {
			return this.fetchedPolicy.otherContractHolders
				? this.fetchedPolicy.otherContractHolders
				: []
		},
		computedInfo() {
			return {
				status: this.fetchedPolicy.status,
				createdAt: this.fetchedPolicy.createdAt,
				createdBy: this.fetchedPolicy.createdBy,
				lastModifiedAt: this.fetchedPolicy.lastModifiedAt,
				lastModifiedBy: this.fetchedPolicy.lastModifiedBy
			}
		},
		computedProduct() {
			return this.fetchedPolicy?.product || {}
		},
		computedPricing() {
			return this.fetchedPolicy?.premium || {}
		},
		computedNotes() {
			return this.fetchedPolicy.notes ? this.fetchedPolicy.notes : []
		},
		computedPaymentInfo() {
			return this.fetchedPolicy.paymentInfos
				? this.fetchedPolicy.paymentInfos
				: []
		},
		computedBeneficiariesInfo() {
			return this.fetchedPolicy.beneficiaryEligibilities
				? this.fetchedPolicy.beneficiaryEligibilities
				: []
		},
		computedAttachments() {
			return this.fetchedPolicy?.attachments
				? this.fetchedPolicy?.attachments
				: []
		},
		// For Fi-Life, we get the list of attachements from fileListing
		computedFiles() {
			return this.fetchedFiles ? this.fetchedFiles : []
		},
		computedInsuredPeople() {
			const insureds = get(this, "fetchedPolicy.contractInsured")
			if (!insureds) return []
			// Filter out only insured people, ignore objects
			return insureds.filter(item => item.__typename === "individual")
		},
		computedInsuredObjects() {
			const insureds = get(this, "fetchedPolicy.contractInsured")
			if (!insureds) return []
			// Filter out only insured objects, ignore individuals
			return insureds.filter(item => item.__typename === "object")
		},
		computedBenefitOptions() {
			const benefitOptions = get(
				this,
				"fetchedPolicy.acceptedOffer.benefitOptions"
			)
			if (!benefitOptions) return []
			return benefitOptions
		},
		canWritePolicyNotes() {
			return can("writePolicyNotes") && this.isCurrent
		},
		canWriteFiles() {
			return can("writeFiles") && this.isCurrent
		}
	},
	methods: {
		travelToDate(item) {
			this.$modal.hide("timeline")
			this.displayedEvent = item
			this.fetchPolicy(item.timestamp)
		},
		async onChangePolicyDetail(changeType) {
			this.isLoading = true
			// Call API
			const res =
				changeType == "update"
					? await this.updates.currentUpdate.update(
							this.updates.currentUpdate.value
					  )
					: changeType == "remove"
					? await this.updates.currentUpdate.remove(
							this.updates.currentUpdate.value
					  )
					: await this.updates.currentUpdate.add(
							this.updates.currentUpdate.value
					  )
			this.isLoading = false
			// Check status and fetch
			if (res?.status === "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "success",
						text: "Changes successfully saved."
					}
				})
				this.$modal.hide("modalEditor")
				this.fetchPolicy()
			}
		},
		openAddEntity(label, addCall, options) {
			console.log("openAddEntity called")
			this.updates.currentUpdate = {
				label: label,
				component: "AddNewEntity",
				componentProps: { createOptions: options },
				hideButtons: true,
				hideLabel: true,
				noPadding: true,
				type: "add",
				add: async input => {
					const query = gql`
							mutation ${addCall}(
								$policyId: String!
								$entityId: String!
							) {
								${addCall}(
									policyId: $policyId
									entityId: $entityId
								) {
									createdStatus {
										id
									}
									errors
									status
								}
							}
					`
					const variables = {
						entityId: input.id,
						policyId: this.id
					}
					const res = await globalApi({ query, variables })
					if (res?.data?.[addCall]?.createdStatus?.id) {
						return { status: "success", id: res.data[addCall].createdStatus.id }
					} else {
						this.$store.dispatch("addMessage", {
							message: {
								type: "error",
								text: res?.errors
									? res?.errors
									: res?.data?.[addCall]?.errors
									? res?.data?.[addCall]?.errors
									: res?.data?.[addCall]?.errors_2.message
									? res?.data?.[addCall]?.errors_2.message
									: "Oops ! An error occured."
							}
						})
						return { status: "error", id: "" }
					}
				}
			}
			this.$nextTick().then(() => {
				this.$modal.show("modalEditor")
			})
		},
		async fetchFiles() {
			// Clear current files / subfolders
			this.isLoading = true
			const query = gql`
				query fileListing($prefix: String, $bucketName: String) {
					fileListing(prefix: $prefix, bucketName: $bucketName) {
						commonPrefixes
						objectSummaries {
							fileName
							key
							lastModifiedAt
							size
						}
					}
				}
			`
			const variables = {
				prefix: "policies/" + this.id + "/attachments/",
				//bucketName: this.bucketName
				bucketName: "filife--uat" // TODO: Fix this asap. Done in emergency because demo is in 35min. Need to fetch bucket list and pick one
			}
			const res = await globalApi({ query, variables })
			this.isLoading = false
			if (!res?.data?.fileListing)
				this.$store.dispatch("showError", ["Error when fetching the folder"])
			this.fetchedFiles = res?.data?.fileListing?.objectSummaries || []
		},
		async fetchPolicy(asOf) {
			this.isLoading = true
			const res = await api.policy({
				where: { id: this.id },
				asOf
			})
			this.isLoading = false
			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}
			// If it doesn't exist, redirect
			if (res.data.policies.list.length === 0)
				this.$router.push({ name: "PoliciesList" })
			// Assign
			this.fetchedPolicy = res.data.policies.list[0]

			// *******************************
			// MOCK
			// *******************************
			// this.fetchedPolicy.status = "MOCK"

			this.policyIsFetched++
		},
		afterCancellation() {
			this.fetchPolicy()
			this.$modal.hide("cancelPolicy")
		},
		async onDelete(id) {
			this.isLoading = true
			const res = await api.deletePolicy({ id })
			this.isLoading = false
			// Error
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
			}
			// go back to previous page
			if (res) this.$router.push(`/${this.$store.state.tenantId}/policies/`)
			this.$store.dispatch("addMessage", {
				message: {
					type: "success",
					text: this.$t("policy_deleted")
				}
			})
		}
	},
	created() {
		// Check if we are receiving all props
		// If not, redirect to products listing
		if (!this.id) {
			this.$router.push({ name: "PoliciesList" })
			return
		}
		// Fetch product info
		this.fetchPolicy()
		if (this.$store.state.tenantId === "fiLife_uat") this.fetchFiles()
	}
}
</script>
